export const PageDataState = {
    Searchs: {
        supply_hr_id: {
            type: 'text',
            id: 'supply_hr_id',
            label: '',
            value: '',
            placeholder: ''
        },
        education_level_id: {
            type: 'select',
            id: 'education_level_id',
            label: 'ระดับการศึกษา',
            value: '',
            placeholder: 'ระดับการศึกษา'
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false
            },
            error: { status: null, msg: '' }
        },
        supply_hr_id: {
            type: 'select',
            id: 'supply_hr_id',
            label: 'สาขางาน',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        education_level_id: {
            type: 'select',
            id: 'education_level_id',
            label: 'ระดับการศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        }, 
        years: {
            type: 'select',
            id: 'years',
            label: 'ปี',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 4,
                maxLength: 4
            },
            error: { status: null, msg: '' }
        },
        entry_amount: {
            type: 'text',
            id: 'entry_amount',
            label: 'เข้ารับการศึกษา',
            value: '',
            validator: {
                type: 'number',
                required: false,
                min: 10,
                max: 1000000
            },
            error: { status: null, msg: '' }
        },  
        release_amount: {
            type: 'text',
            id: 'release_amount',
            label: 'สำเร็จการศึกษา',
            value: '',
            validator: {
                type: 'number',
                required: false,
                min: 1,
                max: 1000000
            },
            error: { status: null, msg: '' }
        },                            
    },
    InputGroup: {}
}